import { Link } from 'react-router-dom';
import { LINE_OFFICIAL_URL } from '@/pages/gmb-audit/consult/config';

/**
 * V1 Conversion-1.2｜搜尋 no-results 狀態下的低壓轉換出口。
 * 僅在真正「找不到商家」時顯示；不與 api-error / quota-error / rate limit / daily limit
 * / maintenance / restricted 等系統或安全錯誤混用（那些由 StateNotice 負責）。
 * 不改任何搜尋邏輯，也不在連結附加 query / city / placeId / token。
 */
export default function NoResultsCta() {
  return (
    <div className="mt-5 rounded-2xl border border-background-300 bg-background-50 p-5 shadow-card md:p-7">
      <div className="flex items-start gap-3.5">
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary-100 text-primary-800">
          <i className="ri-customer-service-2-line text-xl" />
        </span>
        <div className="min-w-0">
          <h3 className="text-lg font-bold text-foreground-950 md:text-xl">還是找不到您的 Google 商家？</h3>
          <p className="mt-2 text-base leading-relaxed text-foreground-600">
            如果已確認店家名稱與地區仍搜尋不到，可能與 Google 公開資料名稱、服務區域設定或資料狀態有關。您可以把店家名稱告訴我們，我們協助您確認下一步。
          </p>
        </div>
      </div>

      <div className="mt-5 flex flex-col gap-3 sm:flex-row sm:items-center">
        <a
          href={LINE_OFFICIAL_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex h-14 w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-xl bg-primary-700 px-6 text-base font-semibold text-background-50 transition-colors hover:bg-primary-800 sm:w-auto"
        >
          <i className="ri-line-fill text-lg" />
          加入 LINE 詢問
        </a>
        <Link
          to="/gmb-audit/consult"
          className="inline-flex h-14 w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-xl border border-background-400 bg-background-50 px-6 text-base font-semibold text-foreground-700 transition-colors hover:bg-background-100 sm:w-auto"
        >
          <i className="ri-calendar-check-line text-lg" />
          預約諮詢
        </Link>
      </div>
    </div>
  );
}